import React from "react";
import QuillNoteHeading from "../UiElements/QuillNoteHeading";
import { Button } from "@material-ui/core";
import { Link} from "react-router-dom";

function NewExercise() {
  return (
    <>
      <QuillNoteHeading subHeading="instructor" />
      <Link to="/instructor/write_exercise">
          <Button
            style={{ marginTop: "10px" }}
            className="CustomButton w100"
            variant="contained"
            size="large"
          >
            New Exercise
          </Button>
        </Link>
    </>
  );
}

export default NewExercise;
